import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=53806c1a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53806c1a')) {
      api.createRecord('53806c1a', component.options)
    } else {
      api.reload('53806c1a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=53806c1a&", function () {
      api.rerender('53806c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vunlxVtyrreD/JS/comp/ErrorMessage.vue"
export default component.exports